import { Box, FormControlLabel, Switch } from "@material-ui/core";
import { COLORS } from "config/theme";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

const DeletedSwitch = ({
  showDeleted,
  setShowDeleted,
}: {
  showDeleted: boolean;
  setShowDeleted: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      alignItems="center"
      gridGap={16}
      style={{
        border: `1px solid ${COLORS.main}`,
        borderRadius: 10,
        padding: "2px 12px",
        background: "#fff",
      }}
    >
      <span style={{ marginLeft: 16, cursor: "pointer" }} onClick={() => setShowDeleted(v => !v)}>
        {t("item.showDeleted")}
      </span>
      <FormControlLabel
        control={
          <Switch
            checked={!showDeleted}
            onChange={() => setShowDeleted(v => !v)}
            color="secondary"
            size="small"
          />
        }
        label={t("item.showActive")}
        labelPlacement="end"
      />
    </Box>
  );
};
export default DeletedSwitch;
